import React, { useState, useEffect } from 'react';
import '../Create.css';

const TIMES = [
    "12:00am",
    "1:00am",
    "2:00am",
    "3:00am",
    "4:00am",
    "5:00am",
    "6:00am",
    "7:00am",
    "8:00am",
    "9:00am",
    "10:00am",
    "11:00am",
    "12:00pm",
    "1:00pm",
    "2:00pm",
    "3:00pm",
    "4:00pm",
    "5:00pm",
    "6:00pm",
    "7:00pm",
    "8:00pm",
    "9:00pm",
    "10:00pm",
    "11:00pm",
  
]

export default ({ onStartChange, onEndChange }) => {
    const [fromDropdown, setFromDropdown] = useState("12:00am");
    const [toDropdown, setToDropdown] = useState("1:00am");

    const [secondDropdownStart, setSecondDropdownStart] = useState(2);


    useEffect(() => {
       let x = TIMES.findIndex((x) => x === fromDropdown);
            
       setSecondDropdownStart(x + 1);

    }, [fromDropdown])

    const renderSecondDropdownOptions = () => {
        let forwardDates = TIMES.slice(secondDropdownStart)
                        
        return forwardDates.map((time) => {
            return (
                <option value={time}>{time}</option>
            )
        })
    }

    return (
        <>
            <label className="input-label">Time Range:</label>
            <div className="time-range-input-container">
                <div className="time-range-input-wrapper">
                    <label className="range-label">From:</label>
                    <select value={fromDropdown} onChange={(e) => { onStartChange(e.target.value); setFromDropdown(e.target.value) }} className="">
                        {
                            TIMES.map((time) => {
                                return (
                                    <option>{time}</option>
                                )
                            })
                        }
                    </select>
                </div>

                <div className="time-range-input-wrapper">
                    <label className="range-label">To:</label>
                    <select value={toDropdown} onChange={e => {  onEndChange(e.target.value); setToDropdown(e.target.value) }} className="">
                        {renderSecondDropdownOptions()}
                    </select>
                </div>
                
            </div>
        </>
    );
}